import React, { useState } from "react";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
  LockOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import { Layout, Menu, Button, theme, Dropdown, Space } from "antd";
import { Footer } from "antd/es/layout/layout";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { selector } from "../api";
import { authActions } from "../actions/auth";
import { useDispatch } from "react-redux";
import ErrorBoundary from "../utils/ErrorBoundary";

const { Header, Sider, Content } = Layout;

function getItem(label, key, icon, children) {
  return { key, icon, children, label };
}

const item = [
  getItem(
    <Link to={"/home"} className="text-decoration-none fs-16">
      Dashboard
    </Link>,
    "home",
    <i className="ri-apps-2-line fs-4" />
  ),
  getItem(
    <span className="fs-16">Venue Management</span>,
    "sub1",
    <i className="ri-building-line fs-4" />,
    [
      getItem(
        <Link to={"/campas"} className="text-decoration-none fs-15">
          Campus
        </Link>,
        "campas"
      ),
      getItem(
        <Link to={"/building"} className="text-decoration-none fs-15">
          Building
        </Link>,
        "building"
      ),
      getItem(
        <Link to={"/room"} className="text-decoration-none fs-15">
          Room / Venue
        </Link>,
        "room"
      ),
    ]
  ),
  getItem(
    <span className="fs-16">Timetable</span>,
    "sub2",
    <i className="ri-calendar-schedule-line fs-4" />,
    [
      getItem(
        <Link to={"/accademic"} className="text-decoration-none fs-15">
          Academic Year
        </Link>,
        "accademic"
      ),
      getItem(
        <Link to={"/programme"} className="text-decoration-none fs-15">
          Programme
        </Link>,
        "programme"
      ),
      getItem(
        <Link to={"/enrollment"} className="text-decoration-none fs-15">
          Allocations
        </Link>,
        "enrollment"
      ),
      getItem(
        <Link to={"/timetable"} className="text-decoration-none fs-15">
          Teaching Timetable
        </Link>,
        "timetable"
      ),
      getItem(
        <Link to={"/exam-timetable"} className="text-decoration-none fs-15">
          Examination Timetable
        </Link>,
        "exam-timetable"
      ),
      getItem(
        <Link to={"/uploaded-timetable"} className="text-decoration-none fs-15">
          Uploaded Timetables
        </Link>,
        "uploaded-timetable"
      ),
    ]
  ),
  getItem(
    <span className="fs-16">Settings</span>,
    "sub3",
    <i className="ri-settings-3-line fs-4" />,
    [
      getItem(
        <Link to={"/settings/room-constraints"} className="text-decoration-none fs-15">
          Room Constraints
        </Link>,
        "room-constraints"
      ),
      getItem(
        <Link to={"/settings/instructor-preferences"} className="text-decoration-none fs-15">
          Instructor Preferences
        </Link>,
        "instructor-preferences"
      ),
    ]
  ),
];

export default function SuzaLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = selector.User();

  theme.useToken();

  const handleLogout = () => {
    dispatch(authActions.setAuth(null));
    dispatch(authActions.getToken({}));
    dispatch(authActions.getUser({}));
    localStorage.removeItem("persist:root");
    navigate("/", { replace: true });
  };

  const handleLock = () => {
    dispatch(authActions.setLock(true));
    dispatch(authActions.setAuth(null));
    navigate("/lockscreen", { replace: true });
  };

  const items = [
    { label: "Profile", key: "profile", icon: <UserOutlined /> },
    {
      label: (
        <span onClick={handleLock}>Lock Screen</span>
      ),
      key: "lock",
      icon: <LockOutlined />,
    },
    {
      label: (
        <span onClick={handleLogout}>Logout</span>
      ),
      key: "out",
      icon: <LogoutOutlined />,
    },
  ];

  return (
    <Layout>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        style={{
          overflow: "auto",
          height: "100vh",
          position: "fixed",
          left: 0,
          top: 0,
          bottom: 0,
        }}
        width={250}
      >
        {collapsed ? (
          <div style={{ textAlign: "center", padding: "16px 0" }}>
            <img
              src="/assets/images/suza.jpeg"
              alt="SUZA"
              style={{ width: 40, height: 40, borderRadius: "50%", objectFit: "cover" }}
            />
          </div>
        ) : (
          <div style={{ textAlign: "center", padding: "20px 16px 12px" }}>
            <img
              src="/assets/images/suza.jpeg"
              alt="SUZA"
              style={{ width: 64, height: 64, borderRadius: "50%", objectFit: "cover", border: "3px solid rgba(255,255,255,0.2)", marginBottom: 10 }}
            />
            <p style={{ color: "#fff", fontWeight: 700, fontSize: 20, margin: "0 0 2px" }}>SUZA</p>
            <p style={{ color: "rgba(255,255,255,0.7)", fontSize: 13, margin: "0 0 12px" }}>Timetable System</p>
            <div style={{ height: 2, background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)" }} />
          </div>
        )}
        <Menu
          theme="dark"
          className="fs-6"
          defaultSelectedKeys={["home"]}
          mode="inline"
          items={item}
        />
      </Sider>
      <Layout style={{ marginLeft: collapsed ? 80 : 250, transition: "margin-left 0.2s" }}>
        <Header
          style={{
            padding: 0,
            background: "linear-gradient(90deg, #25bb57 0%, #2596be 100%)",
            color: "#ffffff",
            borderBottom: "3px solid #dee300",
            position: "sticky",
            top: 0,
            zIndex: 1,
          }}
        >
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{
              fontSize: "16px",
              width: 64,
              height: 64,
              color: "#ffffff",
            }}
          />
          <div className="position-absolute top-0 end-0">
            <Dropdown menu={{ items }} className="me-4 cursor-pointer">
              <Space>
                <i className="ri-user-line fs-5" />
                {user?.username || "User"}
              </Space>
            </Dropdown>
          </div>
        </Header>
        <Content
          style={{
            margin: "24px 16px",
            padding: 24,
            minHeight: 280,
            background: "whitesmoke",
          }}
        >
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </Content>
        <Footer style={{ textAlign: "center" }}>
          <p>
            <span className="fw-bold">
              Time Table &copy;{new Date().getFullYear()}
            </span>{" "}
            &nbsp; | Created by <span className="text-success">SUZA</span>
          </p>
          <p className="fw-light h6 text-success fs-10 fst-italic mt-2">
            ---- catalyst for social change ----
          </p>
        </Footer>
      </Layout>
    </Layout>
  );
}
